import FileSettingsItemContainer from './FileSettingsItemContainer';

export default FileSettingsItemContainer;
